var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1152,
    height: 803,
    viewBox: "0 0 1152 803",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1126.52 398.018C1036.16 427.634 956.745 6.0018 895.028 26.2281C831.1 47.1791 1080.38 694.883 1011.9 717.324C946.144 738.875 781.439 126.064 715.558 147.655C652.099 168.452 864.029 703.177 795.315 725.697C729.897 747.136 601.525 247.636 536.027 269.101C473.395 289.627 657.745 708.173 578.787 734.049C499.83 759.926 430.282 381.101 365.637 402.287C304.514 422.319 434.155 720.02 376.734 738.839C327.982 754.816 266.235 498.489 212.816 515.996C159.396 533.503 248.987 748.22 201.985 763.623C159.316 777.607 120.02 605.545 81.774 618.08C43.528 630.614 111.683 759.646 62.9145 775.629C51.1157 779.496 41.7815 774.935 25.4379 756.96",
    stroke: "url(#paint0_linear_1972_18561)",
    strokeWidth: 50.879,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1972_18561",
    x1: 41.6407,
    y1: 764.151,
    x2: 814.155,
    y2: 716.765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F5FF",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgIcon);
export default __webpack_public_path__ + "static/media/bg_icon.51cfa32499683bcbb39ca6e09c81416b.svg";
export { ForwardRef as ReactComponent };